import React from "react"
import { createUseStyles } from "react-jss"
import { getImage } from "helpers/image"

const useStyles = createUseStyles(theme => {
  return {}
})

type Props = {
  part: any
}

const TableIcon: React.FC<Props> = (props: Props) => {
  const classes = useStyles()

  const icon = getImage(props.part?.tableIcon, "thumbnail")

  return icon ? (
    <div
      style={
        props.part.tableIconVertical
          ? {
              display: "table",
            }
          : null
      }
    >
      <div
        style={
          props.part.tableIconVertical
            ? {
                marginRight: "10px",
                padding: "50% 0",
                height: 0,
              }
            : {
                marginRight: "10px",
                height: "26px",
              }
        }
      >
        <img
          src={icon}
          alt={props.part.tableName}
          style={
            props.part.tableIconVertical
              ? {
                  height: "26px",
                  display: "block",
                  transformOrigin: "top left",
                  transform: "rotate(-90deg) translate(-100%)",
                  marginTop: "-50%",
                }
              : props.part.tableIsDevice
              ? {
                  width: "26px",
                }
              : {
                  height: "26px",
                }
          }
        />
      </div>
    </div>
  ) : null
}

export default TableIcon
